<template>
  <div class="wrapper">
    <div id="javascriptComponents">
      <div class="title">
        <h2 class="title text-center">Our work</h2>
      </div>
      <div class="md-layout">
        <div class="md-layout-item md-size-66 mx-auto md-small-size-100">
          <md-card>
            <carousel
              height="100px"
              :per-page="1"
              loop
              :speed="700"
              autoplay
              :autoplay-timeout="5000"
              :mouse-drag="false"
              navigationEnabled
              navigationNextLabel="<i class='material-icons'>keyboard_arrow_right</i>"
              navigationPrevLabel="<i class='material-icons'>keyboard_arrow_left</i>"
            >
              <slide v-for="(n, i) in this.img.length" :key="n">
                <div class="carousel-caption">
                  <h4>
                    <md-icon>location_on</md-icon>
                    Toronto
                  </h4>
                </div>
                <img :src="getImage(i)" alt="Toronto" />
              </slide>
            </carousel>
          </md-card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      img: [
        require("@/assets/img/gvc/space1.jpg"),
        require("@/assets/img/gvc/space2.jpg"),
        require("@/assets/img/gvc/space3.jpg"),
        require("@/assets/img/gvc/space4.jpg")
      ]
    };
  },
  methods: {
    getImage(item) {
      return this.img[item];
    }
  }
};
</script>
